// extracted by mini-css-extract-plugin
export default {"loader":"YTjy2","spinner":"_2u9E9","rotate-ltr":"_2hhN2","rotateLtr":"_2hhN2","rotate-rtl":"G15_T","rotateRtl":"G15_T","path":"_2N2WA","dash":"ASvmY"};